<template lang="html">
	<div class="manager-track-report center-panel report">
		<md-content md-theme="white" v-loader-overlay="progress" class="md-elevation-1">
			<sort-table
				v-bind:columns="tableColumns" v-model="reports" @refresh="getReports" v-bind:per-page="perPage" 
				v-bind:total="reportsAmount" table-id="report" default-order="desc" default-sort="id"
				v-bind:showAddButton="false"
			>
			</sort-table>
		</md-content>
	</div>
</template>
<script>
	import SortTable from "@/components/SortTable"
	import reportsMenu from './reports-menu';
	export default {
		components: {SortTable, reportsMenu},
		data() {
			return {
				tableColumns: [
					{label: 'ID',         field: 'id',    sortable: true },
					{label: 'Экспедитор', field: 'login', sortable: true },
					{label: 'Экспедиторований всего',    field: 'forward_count',       sortable: true },
					{label: 'Экспедиторований за текущий месяц', field: 'forward_count_month', sortable: true },
				],
				currentPage: 1,
				perPage: 50,
				filter: null,
			}
		},
		created() {
			this.$store.commit('setTitle', 'Отчет для диспетчера');
		},
		watch: {
			'$route.query.filter'(filter) {
				if (filter) this.filter = Object.assign({}, JSON.parse(filter));
				else this.filter = null;
				this.getReports(this.currentPage, this.perPage, 'id', 'desc');
			}
		},
		computed: {
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj['get-dispatcher-reports'];
			},
			/**
			 * Объект флагов загрузки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			},
			/**
			 * Список отчетов
			 */
			reports() {
				return this.$store.state.reports.dispatcher_report;
			},
			/**
			 * Количество отчетов
			 */
			reportsAmount() {
				return this.$store.state.reports.dispatcher_report_amount
			},
		},
		methods: {
			/**
			 * Получение отчетов
			 */
			getReports(page, count, orderBy, orderType) {
				this.$store.commit('showProgressBar', 'get-dispatcher-reports');
				let data = {
					page:       (page)        ? page        : 1, 
					order_by:   (orderBy)     ? orderBy     : 'id', 
					order_type: (orderType)   ? orderType   : 'desc',
					count:      (count)       ? count       : 50,
					filter:     (this.filter) ? this.filter : null 
				};
				return this.$store.dispatch('reports/getDispatcherReport', data)
					.finally(() => this.$store.commit('hideProgressBar', 'get-dispatcher-reports'));
			},
		}
	}
</script>


// WEBPACK FOOTER //
// DispatcherReport.vue?76c571b6